// extracted by mini-css-extract-plugin
module.exports = {"BACKGROUND_BLUE":"#EDF4FB","container":"styles_container__qrEkq","continueButton":"styles_continueButton__w5rQO","submitButton":"styles_submitButton__jvo7p"};